import Container from './PrimaryDesktopActionBar.container';
import PrimaryDesktopActionBar from './PrimaryDesktopActionBar';
export default Container(PrimaryDesktopActionBar);
//# sourceMappingURL=index.js.map